module.exports = __webpack_public_path__ + "img/cymbalRight.70768aac.svg";